import {
  FETCH_USER,
  FETCH_USER_SUCCESS,
  CREATE_USER,
  CREATE_USER_SUCCESS,
  CREATE_USER_ERROR,
  FETCH_USER_LIST,
  FETCH_USER_LIST_SUCCESS,
  FETCH_USER_LIST_ERROR,
  FETCH_USER_ERROR,
  SAVE_USER,
  SAVE_USER_SUCCESS,
  SAVE_USER_ERROR,
  CLEAR_CURRENT_USER,
  REMOVE_USER,
  REMOVE_USER_SUCCESS,
  REMOVE_USER_ERROR,
  UPDATE_USER_SEARCH,
  EDIT_USER_ROLES,
  EDIT_USER_ROLES_SUCCESS,
  EDIT_USER_ROLES_ERROR,
  ASSIGN_USER_LOCATION_ROLES,
  ASSIGN_USER_LOCATION_ROLES_SUCCESS,
  ASSIGN_USER_LOCATION_ROLES_ERROR,
  RESEND_USER_INVITE,
  RESEND_USER_INVITE_SUCCESS,
  RESEND_USER_INVITE_ERROR,
  REVOKE_USER_INVITE,
  REVOKE_USER_INVITE_SUCCESS,
  REVOKE_USER_INVITE_ERROR,
} from '../constants/ActionTypes';
import { CustomAction } from 'model/state';
import { User, Location, Credentials, PermissionsEnum } from 'model';

/**
 * Payload
 */
export interface UserPayload {
  userId?: string;
  user?: User;
  email?: string;
  accountId?: string;
  users?: User[];
  search?: string;
  locations?: Location[];
  credentials?: Credentials;
  roles?: PermissionsEnum[];
  enabledFeatures?: string[];
}

/**
 * Actions
 */
export const fetchUser = (userId: string): CustomAction<UserPayload> => {
  return {
    type: FETCH_USER,
    payload: { userId }
  };
};

export const fetchUserSuccess = (user: User): CustomAction<UserPayload> => {
  return {
    type: FETCH_USER_SUCCESS,
    payload: { user }
  };
};

export const fetchUserList = (accountId: string): CustomAction<UserPayload> => {
  return {
    type: FETCH_USER_LIST,
    payload: { accountId }
  };
};

export const fetchUserError = (): CustomAction<UserPayload> => {
  return {
    type: FETCH_USER_ERROR,
  };
};

export const fetchUserListSuccess = (users: User[]): CustomAction<UserPayload> => {
  return {
    type: FETCH_USER_LIST_SUCCESS,
    payload: { users }
  };
};

export const fetchUserListError = (): CustomAction<UserPayload> => {
  return {
    type: FETCH_USER_LIST_ERROR,
  };
};

export const createUser = (user: User): CustomAction<UserPayload> => {
  return {
    type: CREATE_USER,
    payload: { user }
  };
};

export const createUserSuccess = (): CustomAction<UserPayload> => {
  return {
    type: CREATE_USER_SUCCESS,
  };
};

export const createUserError = (): CustomAction<UserPayload> => {
  return {
    type: CREATE_USER_ERROR,
  };
};

export const resendUserInvite = (user?: User): CustomAction<UserPayload> => {
  return {
    type: RESEND_USER_INVITE,
    payload: { user }
  };
};

export const resendUserInviteSuccess = (): CustomAction<UserPayload> => {
  return {
    type: RESEND_USER_INVITE_SUCCESS,
  };
};

export const resendUserInviteError = (): CustomAction<UserPayload> => {
  return {
    type: RESEND_USER_INVITE_ERROR,
  }
}

export const revokeUserInvite = (user?: User): CustomAction<UserPayload> => {
  return {
    type: REVOKE_USER_INVITE,
    payload: { user }
  };
};

export const revokeUserInviteSuccess = (): CustomAction<UserPayload> => {
  return {
    type: REVOKE_USER_INVITE_SUCCESS,
  };
};

export const revokeUserInviteError = (): CustomAction<UserPayload> => {
  return {
    type: REVOKE_USER_INVITE_ERROR,
  }
}

export const saveUser = (user: User, credentials?: Credentials): CustomAction<UserPayload> => {
  return {
    type: SAVE_USER,
    payload: { user, credentials }
  };
};

export const saveUserSuccess = (): CustomAction<UserPayload> => {
  return {
    type: SAVE_USER_SUCCESS,
  };
};

export const saveUserError = (): CustomAction<UserPayload> => {
  return {
    type: SAVE_USER_ERROR,
  };
};

export const clearCurrentUser = (): CustomAction<UserPayload> => {
  return {
    type: CLEAR_CURRENT_USER,
  };
};

export const removeUser = (userId: string): CustomAction<UserPayload> => {
  return {
    type: REMOVE_USER,
    payload: { userId }
  };
};

export const removeUserSuccess = (userId: string): CustomAction<UserPayload> => {
  return {
    type: REMOVE_USER_SUCCESS,
    payload: { userId }
  };
};

export const removeUserError = (): CustomAction<UserPayload> => {
  return {
    type: REMOVE_USER_ERROR,
  };
};

export const updateSearch = (search: string): CustomAction<UserPayload> => {
  return {
    type: UPDATE_USER_SEARCH,
    payload: { search }
  };
};

export const editUserRoles = (user: User): CustomAction<UserPayload> => {
  return {
    type: EDIT_USER_ROLES,
    payload: { user }
  };
};

export const editUserRolesSuccess = (): CustomAction<UserPayload> => {
  return {
    type: EDIT_USER_ROLES_SUCCESS,
  };
};

export const editUserRolesError = (): CustomAction<UserPayload> => {
  return {
    type: EDIT_USER_ROLES_ERROR,
  };
};

export const assignUserLocationRoles = (roles: PermissionsEnum[], userId: string): CustomAction<UserPayload> => {
  return {
    type: ASSIGN_USER_LOCATION_ROLES,
    payload: { roles, userId }
  };
};

export const assignUserLocationRolesSuccess = (): CustomAction<UserPayload> => {
  return {
    type: ASSIGN_USER_LOCATION_ROLES_SUCCESS,
  };
};

export const assignUserLocationRolesError = (): CustomAction<UserPayload> => {
  return {
    type: ASSIGN_USER_LOCATION_ROLES_ERROR,
  };
};
